import { render } from "./404.vue?vue&type=template&id=011794e8"
const script = {}
script.render = render

export default script